import axios from "../../../../axios";
import React, { useState } from "react";
import "./queryList.css";
import { toast } from "react-toastify";

function DeclineQuery({
  queryStatus,
  setQuery,
  queryId,
  setChangeStatus,
  handleRefresh,
}) {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isInProgress, setIsInProgress] = useState(false);
  const handleQueryStatus = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.put(`api/v1/query/updateStatus/${queryId}`, {
        user_id: teacher_id,
        updatedStatus: queryStatus,
      });
      res &&
        setQuery((prevQuery) => {
          return prevQuery
            .map((query) => {
              if (query.id === queryId && queryStatus === "rejected") {
                return null;
              } else if (
                query.id === queryId &&
                (queryStatus === "approved" || queryStatus === "resolved")
              ) {
                return { ...query, status: queryStatus };
              } else {
                return query;
              }
            })
            .filter((query) => query !== null);
        });
      toast.success(res?.data?.message);
      handleRefresh();
      localStorage.setItem("pendingApproved", true);
      setChangeStatus(false);
    } catch (error) {
      setIsInProgress(false);
      toast.error(error.response.data.message);
      console.log(error);
      setChangeStatus(false);
    }
  };

  return (
    <div className=" delete_query_transprant_body ">
      <img
        src="/images/cross-circle3.svg"
        className=" delete_query_close_btn"
        alt=""
        onClick={(e) => setChangeStatus(false)}
      />
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            {`Are you sure you want to ${
              queryStatus === "rejected" ? "reject" : "approve"
            } this Query?`}
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={handleQueryStatus}
            >
              Yes
            </button>
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn "
              onClick={(e) => setChangeStatus(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeclineQuery;
